import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  IconDashboard,
  IconProducts,
  IconCategories,
  IconOrders,
  IconCalendar,
  IconStar,
  IconImage,
  IconContent,
  IconBlog,
  IconTruck,
  IconSearch,
  IconSettings,
  IconUser,
  IconUsers,
  IconChevronLeft,
  IconChevronRight,
} from './Icons';
import './Layout.css';

const Layout = ({ children }) => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/dashboard', Icon: IconDashboard, label: 'Tableau de Bord' },
    { path: '/products', Icon: IconProducts, label: 'Produits' },
    { path: '/categories', Icon: IconCategories, label: 'Catégories' },
    { path: '/orders', Icon: IconOrders, label: 'Commandes' },
    { path: '/appointments', Icon: IconCalendar, label: 'Rendez-vous' },
    { path: '/reviews', Icon: IconStar, label: 'Avis' },
    { path: '/hero-slides', Icon: IconImage, label: 'Hero Slides' },
    { path: '/content', Icon: IconContent, label: 'Contenu' },
    { path: '/blog', Icon: IconBlog, label: 'Blog' },
    { path: '/cities', Icon: IconTruck, label: 'Villes / Livraison' },
    { path: '/seo', Icon: IconSearch, label: 'SEO' },
    { path: '/settings', Icon: IconSettings, label: 'Paramètres' },
    { path: '/customers', Icon: IconUser, label: 'Clients' },
    { path: '/users', Icon: IconUsers, label: 'Admins' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="admin-layout">
      <aside className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            {!sidebarCollapsed && <span className="logo-text">Optical G&S</span>}
            {sidebarCollapsed && <span className="logo-icon">G&S</span>}
          </div>
          <button
            className="collapse-btn"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            aria-label="Toggle sidebar"
          >
            {sidebarCollapsed ? <IconChevronRight /> : <IconChevronLeft />}
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map(({ path, Icon, label }) => (
            <button
              key={path}
              className={`nav-item ${isActive(path) ? 'active' : ''}`}
              onClick={() => navigate(path)}
              title={sidebarCollapsed ? label : undefined}
            >
              <span className="nav-icon"><Icon /></span>
              {!sidebarCollapsed && <span className="nav-label">{label}</span>}
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="admin-info">
            {!sidebarCollapsed && (
              <>
                <div className="admin-name">{admin?.name}</div>
                <div className="admin-role">{admin?.role}</div>
              </>
            )}
          </div>
        </div>
      </aside>

      <div className="main-content">
        <header className="header">
          <div className="header-left">
            <h1 className="page-title">
              {menuItems.find((item) => item.path === location.pathname)?.label || 'Admin'}
            </h1>
          </div>
          <div className="header-right">
            <div className="admin-dropdown">
              <button className="admin-btn">
                <span className="admin-avatar">{admin?.name?.charAt(0)}</span>
                <span className="admin-name-header">{admin?.name}</span>
              </button>
              <div className="dropdown-menu">
                <button onClick={() => navigate('/profile')}>Profil</button>
                <button onClick={handleLogout}>Déconnexion</button>
              </div>
            </div>
          </div>
        </header>

        <main className="page-content">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
